/* GLUCEN — EasySell COD
   El color del boton "COMPLETAR PEDIDO" lo pinta la app con un
   style inline con !important, asi que ningun CSS lo puede ganar.
   Lo reescribimos por JS. Si algun dia se cambia el color dentro
   de la app de EasySell, este archivo se puede borrar. */
(function () {
  var WINE = '#972A25';
  function pintar() {
    document.querySelectorAll('#es-form-button, #easysell .es-cta-btn').forEach(function (b) {
      if (b.dataset.glPintado === WINE) return;
      b.style.setProperty('background-color', WINE, 'important');
      b.style.setProperty('color', '#fff', 'important');
      b.dataset.glPintado = WINE;
    });
  }
  pintar();
  document.addEventListener('DOMContentLoaded', pintar);
  new MutationObserver(pintar).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class']
  });
})();

/* ---------- Carrito lateral (como en moovers) ----------
   1) El boton COD que EasySell mete en el carrito pasa a ser el principal,
      en vinotinto y con el texto en español (la app lo deja en ingles).
   2) El boton de checkout del tema se lleva el cupon del 10%.
   Igual que el de "COMPLETAR PEDIDO", estos los pinta la app con style
   inline !important, asi que no hay CSS que los gane: van por JS. */
(function () {
  var WINE = '#972A25', DEEP = '#6E1C19', COD_LABEL = 'Pagarlo al recibir';
  var CUPON = 'PAGOONLINE10';

  function imp(el, p, v) { el.style.setProperty(p, v, 'important'); }

  function carrito() {
    document.querySelectorAll('.es-popup-button-drawer').forEach(function (b) {
      if (b.getAttribute('style') === b.dataset.glStyle) return;
      imp(b, 'background', WINE);
      imp(b, 'color', '#fff');
      imp(b, 'border', 'none');
      imp(b, 'border-radius', '14px');
      imp(b, 'min-height', '54px');
      imp(b, 'font-size', '16px');
      imp(b, 'font-weight', '700');
      imp(b, 'box-shadow', '0 2px 0 rgba(74,18,15,.22), 0 10px 24px rgba(151,42,37,.26)');
      imp(b, 'order', '-1');            /* arriba del boton de pagar online */
      b.dataset.glStyle = b.getAttribute('style');
    });
    /* El texto lo deja la app en ingles */
    document.querySelectorAll('.es-popup-button-drawer .es-button-title, .es-popup-button-drawer span').forEach(function (s) {
      if (/cash on delivery|order now|contraentrega/i.test(s.textContent) && s.textContent.trim() !== COD_LABEL) {
        s.textContent = COD_LABEL;
      }
    });
    /* que los dos botones queden uno arriba del otro */
    document.querySelectorAll('.cart__ctas').forEach(function (c) {
      imp(c, 'display', 'flex'); imp(c, 'flex-direction', 'column'); imp(c, 'gap', '10px');
    });
  }

  /* "Pagar online · 10% OFF": al checkout con el cupon puesto */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#CartDrawer-Checkout, button[name="checkout"]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href = '/checkout?discount=' + CUPON;
  }, true);

  carrito();
  document.addEventListener('DOMContentLoaded', carrito);
  var pend = false;
  new MutationObserver(function () {
    if (pend) return; pend = true;
    setTimeout(function () { pend = false; carrito(); }, 40);
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });
})();
